import { put } from 'redux-saga/effects';

import { showToast } from '../components/toast/toastSlice';

export function showFetchError() {
  return put(
    showToast({
      type: 'error',
      message: 'Something went wrong, please try again'
    })
  );
}
